
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedInleftRight0 as ObiThreewayStackedInleftRight0Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-inleft-right-0.js';
 
 
 

 
 export const ObiThreewayStackedInleftRight0 = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-inleft-right-0',
   elementClass: ObiThreewayStackedInleftRight0Element,
   events: {
     
   }
  });
 
 